export const worksheets = {
  actions: {
    start: 'Автоинформатор',
    media: 'Медиа файл',
    postback: 'Постбэк',
    menu: 'Голосовое меню IVR'
  }
};
